import { cva, type VariantProps } from 'class-variance-authority';
import { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-pill px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-ugin-surface-elevated text-ugin-text border border-ugin-border',
        accent: 'bg-ugin-accent/15 text-ugin-accent border border-ugin-accent/30',
        mystic: 'bg-ugin-mystic/15 text-ugin-mystic border border-ugin-mystic/30',
        success: 'bg-ugin-success/15 text-ugin-success border border-ugin-success/30',
        warn: 'bg-ugin-warn/15 text-ugin-warn border border-ugin-warn/30',
        danger: 'bg-ugin-danger/15 text-ugin-danger border border-ugin-danger/30',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
